import WideInfoView from "./WideInfoView";
import WidePhotoAndInfoView from "./WidePhotoAndInfoView";
import NarrowInfoView from "./NarrowInfoView";
import NarrowPhotoAndInfoView from "./NarrowPhotoAndInfoView";
import Text from "./Text";
import PhotoAndText from "./PhotoAndText";
import WarningView from "./WarningView";
import JustButtonView from "./JustButtonView";
import Sponsors from "./Sponsors";
import HorizontalStats from "./HorizontalStats";
import TwoSidedView from "./TwoSidedView";
import Paragraphs from "./Paragraphs";
import PreislisteTable from "./PreislisteTable";
import GewinnerlisteTable from "./GewinnerlisteTable";
import StatsGrid from "./sections/StatsGrid";
import SellingPointsList from "./sections/SellingPointsList";
import DonorGrid from "./sections/DonorGrid";
import ImageGrid from "./sections/ImageGrid";
import Gallery from "./sections/Gallery";
import LegalContent from "./sections/LegalContent";
import Spacer from "./sections/Spacer";
import BandHeading from "./sections/BandHeading";
import PickupLocation from "./sections/PickupLocation";
import CurrentDonorHero from "./sections/CurrentDonorHero";
import SpendensummeBlock from "./sections/SpendensummeBlock";

const componentMap = {
    WideInfoView,
    WidePhotoAndInfoView,
    NarrowInfoView,
    NarrowPhotoAndInfoView,
    Text,
    PhotoAndText,
    WarningView,
    JustButtonView,
    Sponsors,
    HorizontalStats,
    TwoSidedView,
    Paragraphs,
    PreislisteTable,
    GewinnerlisteTable,
    StatsGrid,
    SellingPointsList,
    DonorGrid,
    ImageGrid,
    Gallery,
    LegalContent,
    Spacer,
    BandHeading,
    PickupLocation,
    CurrentDonorHero,
    SpendensummeBlock,
};

function Section({ component, show, ...props }) {
    if (show === false) return null;
    const Comp = componentMap[component];
    if (!Comp) {
        if (typeof window !== "undefined") {
            console.warn(`Unknown section component: ${component}`);
        }
        return null;
    }
    return <Comp {...props} />;
}

export { componentMap };
export default Section;
